import {
  HbrTab,
  HbrTabGroup,
  HbrTabPanel,
} from '@harbor/elements-react-standalone';
import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import CustomerTreeAdminPage from '../CustomerTree/CustomerTreeAdminPage';
import { DjangoModelAdmin } from '../DjangoModelAdmin';
import { MODELS } from '../RbacConfig';
import { ADMIN_URL_DATA_MANAGMENT } from './admin-values';
import AdminTab from './AdminTab';
import NavHistoryTracker from '../../../navigation/NavHistoryTracker';
import { useAdminPermissions } from '../Hooks/useAdminPermissions';
import EscalationAdminPage from '../Escalation/EscalationAdminPage';


const AdminDataManagement = () => {
  const navigate = useNavigate();
  const { section, id } = useParams();
  const location = useLocation();
  const { isVisibleTab } = useAdminPermissions();
  const dataManagementModels = {
    products: MODELS.products,
    goToMarkets: MODELS.goToMarkets,
    escalation: {
      key: 'escalation',
      label: 'Escalation',
      pageView: 'page.escalationAdmin.view',
    },
    'model-admin': {
      key: 'model-admin',
      label: 'Model Admin',
      pageView: 'page.modelAdmin.view',
    },
    'customer-tree': {
      key: 'customer-tree',
      label: 'Customer Tree',
      pageView: 'page.customerTreeAdmin.view',
    },
  };
  const modelKeys = Object.keys(dataManagementModels).filter(key => isVisibleTab(dataManagementModels[key]));

  const getInitialTab = () => {
    if (location.pathname.includes('goToMarkets')) return 'goToMarkets';
    if (!!section && modelKeys.includes(section)) return section;
    return modelKeys[0];
  };

  const [currentTabKey, setCurrentTabKey] = useState<string>(getInitialTab());
  const { tab1 } = useParams();

  const handleTabClick = (key: string) => {
    setCurrentTabKey(key);
    navigate(`${ADMIN_URL_DATA_MANAGMENT}/${key}`);
  };

  return (
    <>
      <NavHistoryTracker title={tab1 ?? currentTabKey} />
      <h1 className='mt-0 pb-6 border-b border-gray-15 text-gray-60 font-semibold leading-5'>
        Data Management
      </h1>

      <HbrTabGroup primary className='my-4'>
        {modelKeys.map((key) => (
          <HbrTab
            slot='nav'
            panel={key}
            key={key}
            onClick={() => handleTabClick(key)}
            active={key === currentTabKey}
          >
            {dataManagementModels[key].label}
          </HbrTab>
        ))}

        <HbrTabPanel name='products'>
          {currentTabKey === 'products' && (
            <>
              {id && <Outlet />}
              {!id && (
                <AdminTab model={dataManagementModels.products} DialogComponent={() => <></>} editAction={(rowId) =>
                  navigate(`${ADMIN_URL_DATA_MANAGMENT}/products/${rowId}`)
                } />
              )}
            </>
          )}
        </HbrTabPanel>

        <HbrTabPanel name='goToMarkets'>
          {currentTabKey === 'goToMarkets' && (
            <>
              {id && <Outlet />}
              {!id && (
                <AdminTab model={dataManagementModels.goToMarkets} DialogComponent={() => <></>} editAction={(rowId) =>
                  navigate(`${ADMIN_URL_DATA_MANAGMENT}/goToMarkets/${rowId}`)
                } />
              )}
            </>
          )}
        </HbrTabPanel>

        <HbrTabPanel name='escalation'>
          {currentTabKey === 'escalation' && <EscalationAdminPage />}
        </HbrTabPanel>

        <HbrTabPanel name='model-admin'>
          {currentTabKey === 'model-admin' && <DjangoModelAdmin />}
        </HbrTabPanel>

        <HbrTabPanel name='customer-tree'>
          {currentTabKey === 'customer-tree' && <CustomerTreeAdminPage />}
        </HbrTabPanel>
      </HbrTabGroup>
    </>
  );
};

export default AdminDataManagement;